// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mhpO","delete":"styles_delete__2WAY-","update":"styles_update__1zVQo","add":"styles_add__2PoKw"};